import './ApplicationFilter.scss';

import { AntdOptionType } from '@sonar-software/sonar-ts-types';
import { AppDisplay } from '@ui/applications';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { Select } from 'antd';
import { sortBy } from 'lodash';
import { stringContainsSubstringCaseInsensitive } from '@sonar-software/sonar-ts-lib';

import React, { useCallback, useMemo } from 'react';
import { UpdateQueryParams, useDataSecurityApps } from '@hooks';

export type ApplicationFilterParams = { applicationIds?: Array<string> };

export interface ApplicationFilterProps {
	disabled?: boolean;
	onChange: UpdateQueryParams<ApplicationFilterParams>;
	value?: Array<string>;
}

export const ApplicationFilter: React.FC<ApplicationFilterProps> = ({
	disabled,
	onChange,
	value
}) => {
	const apps = useDataSecurityApps(false, false, false);

	const options = useMemo(() => sortBy(apps.map((app) => ({
		label: <AppDisplay appId={ app.applicationId } />,
		optionLabel: app.name,
		value: app.applicationId
	})), (app) => app.label), [ apps ]);

	const handleFilter = (input: string, option?: AntdOptionType) =>
		stringContainsSubstringCaseInsensitive(option?.optionLabel as string, input);

	const onAppSelect = useCallback((appIds?: Array<string>) => {
		onChange({
			applicationIds: appIds
		});
	}, [ onChange ]);

	return (
		<div className='app-filter-container'>
			<Select
				allowClear
				className='app-filter'
				disabled={ disabled }
				filterOption={ handleFilter }
				mode='multiple'
				onChange={ onAppSelect }
				optionFilterProp='label'
				optionLabelProp='optionLabel'
				options={ options }
				placeholder={ COPY_SPECIFIC.APPLICATION }
				value={ value } />
		</div>
	);
};


